import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HeaderService } from './header.service';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BulkTransfersService {
  headers: HttpHeaders;
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private headerService: HeaderService
  ) {
    try {
      this.headers = this.headerService.getXAuthHeaderFromCookie();
    } catch (e) {
      // Breaks tests when we don't trap
    }
  }

  suspend(meu: any): any {
    const url = `${environment.rootApiUrl}/cardholders/marine_transfer/suspend`;
    const params = new HttpParams().set('meu', meu);

    return this.http.post<any>(url, params, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  activate(meu: any): any {
    const url = `${environment.rootApiUrl}/cardholders/marine_transfer/activate`;
    const params = new HttpParams().set('meu', meu);

    return this.http.post<any>(url, params, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  transfer(meu: any, mlg: string, source: any): any {
    const url = `${environment.rootApiUrl}/cardholders/marine_transfer/transfer`;
    const params = new HttpParams()
      .set('meu', meu)
      .set('mlg', mlg)
      .set('source', source);

    return this.http.post<any>(url, params, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  getMeusMmeus(): any {
    const url = `${environment.rootApiUrl}/cardholders/marine_transfer/getMeusMmeus`;
    return this.http.get<any>(url, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }
}
